import React, { useEffect, useState } from 'react';
export function ScrollNav() {
  const [activeSection, setActiveSection] = useState('home');
  useEffect(() => {
    const sections = [{
      id: 'home',
      ref: document.getElementById('home')
    }, {
      id: 'about',
      ref: document.getElementById('about')
    }, {
      id: 'services',
      ref: document.getElementById('services')
    }, {
      id: 'qualifications',
      ref: document.getElementById('qualifications')
    }, {
      id: 'experience',
      ref: document.getElementById('experience')
    }, {
      id: 'availability',
      ref: document.getElementById('availability')
    }, {
      id: 'contact',
      ref: document.getElementById('contact-new')
    }];
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200;
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section.ref && section.ref.offsetTop <= scrollPosition) {
          setActiveSection(section.id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const scrollToSection = id => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };
  const navItems = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'about',
    label: 'Over mij'
  }, {
    id: 'services',
    label: 'Diensten'
  }, {
    id: 'qualifications',
    label: 'Kwalificaties'
  }, {
    id: 'experience',
    label: 'Ervaring'
  }, {
    id: 'availability',
    label: 'Tarieven'
  }, {
    id: 'contact-new',
    label: 'Contact'
  }];
  return <div className="hidden lg:block fixed right-6 top-1/2 transform -translate-y-1/2 z-50" data-id="element-285">
      <div className="bg-zinc-900 rounded-none py-3 px-2 shadow-md border border-zinc-800" data-id="element-286">
        <div className="flex flex-col items-center space-y-4" data-id="element-287">
          {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className={`relative group rounded-full w-3 h-3 transition-all duration-300 ${activeSection === item.id ? 'bg-slate-500' : 'bg-zinc-700 hover:bg-zinc-600'}`} aria-label={item.label} data-id="element-288">
              <span className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 px-3 py-1.5 rounded-none bg-zinc-900 text-white text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-289">
                {item.label}
              </span>
            </button>)}
        </div>
      </div>
    </div>;
}